module.exports = __webpack_public_path__ + "img/Portrait.e41de899.png";